import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOP_ConstructorsDestructors = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return ( 
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Constructors and Destructors"
      videos={[
        "https://www.youtube.com/embed/hAA8FBq2bA4", // Constructors & Destructors in C++
      ]}
      takeaways={[
        { text: "Very important topic from this module." },
        { text: "Learn about different types of constructors and destructors with example code (syntax is important)." },
        { text: "Understand what happens if multiple types of constructors are declared in a class." },
        { text: "Learn the order of execution of destructors." },
      ]}
      questions={[
        "1) Describe various types of constructors and their use with a suitable code snippet.",
        "2) Write a C++ program to create a class FDacc with the members - fdno, name, amt, interest rate, maturity amt & no. of months. Store the values in objects using the parameterized constructor. Provide the default value of 8.6 for the interest rate inside the parameterized constructor. Also, use a destructor to print the line 'object destroyed'. Define a function to calculate the maturity amount using the formula: maturity amount = (Amount * Duration in years * Rate of interest per year) / 100. Create 3 objects and display the details.",
        "3) What is the difference between the following two statements (explain in detail)? time T2(T1); time T2 = T1;",
        "4) List down some of the special characteristics of a constructor.",
      ]}
      exampleVideos={[]} // No example question videos provided
    />
);
}

export default OOP_ConstructorsDestructors;
